import { render, staticRenderFns } from "./HorizontalStepperLabelStep.vue?vue&type=template&id=21b62292&lang=pug"
import script from "./HorizontalStepperLabelStep.vue?vue&type=script&lang=ts"
export * from "./HorizontalStepperLabelStep.vue?vue&type=script&lang=ts"
import style0 from "./HorizontalStepperLabelStep.vue?vue&type=style&index=0&id=21b62292&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports